var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.img),function(item){return _c('img',{key:item.pid,staticClass:"w-100",attrs:{"src":item.purl}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }